uniform sampler2D tDiffuse;
uniform float     uTime;
uniform float     uStrength;

varying vec2 vUv;

float rand(vec2 co) {
  return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}

void main() {
  vec4 color = texture2D(tDiffuse, vUv);

  float noise = rand(vUv + fract(uTime)) * 2.0 - 1.0;  // [-1, 1]
  color.rgb += noise * uStrength;

  gl_FragColor = color;
}
